import create, { SetState, GetState } from 'zustand';

const stateDefault = {
  academicYear: '',
};

const actions = (set, get) => ({
  setAcademicYear: (payload) => {
    set((state) => ({
      academicYear: payload,
    }));
  },
});

export const useAcademicYears = create((set, get) => ({
  ...stateDefault,
  ...actions(set, get),
}));
